import React, {useEffect, useState} from "react";
import {Button, Carousel, Modal, Toast, ToastContainer} from "react-bootstrap";
import queryString from 'query-string';
import Human from "./human";
import Service from "./service/Service";

function App() {
    const service = new Service();

    const [dialog, setDialog] = useState(false);
    const [show, setShow] = useState(false);

    const handleCloseDialog = () => setShow(false);
    const handleShowDialog = () => setShow(true);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const _question = [
        {
            id: 0,
            q: "",
        },
        {
            id: 1,
            q: "",
        },
        {
            id: 2,
            q: "",
        },
        {
            id: 3,
            q: "",
        },
        {
            id: 4,
            q: "",
        },
        {
            id: 5,
            q: "",
            calc: true,
            from: 1,
            group: "brain",
        },
        {
            id: 6,
            q: "",
        },
        {
            id: 7,
            q: "",
        },
        {
            id: 8,
            q: "",
        },
        {
            id: 9,
            q: "",
        },
        {
            id: 10,
            q: "",
            calc: true,
            from: 6,
            group: "eye",
        },
        {
            id: 11,
            q: "",
        },
        {
            id: 12,
            q: "",
        },
        {
            id: 13,
            q: "",
        },
        {
            id: 14,
            q: "",
        },
        {
            id: 15,
            q: "",
            calc: true,
            from: 11,
            group: "hair",
        },
        {
            id: 16,
            q: "",
        },
        {
            id: 17,
            q: "",
        },
        {
            id: 18,
            q: "",
        },
        {
            id: 19,
            q: "",
        },
        {
            id: 20,
            q: "",
            calc: true,
            from: 16,
            group: "nose",
        },
        {
            id: 21,
            q: "",
        },
        {
            id: 22,
            q: "",
        },
        {
            id: 23,
            q: "",
        },
        {
            id: 24,
            q: "",
        },
        {
            id: 25,
            q: "",
            calc: true,
            from: 21,
            group: "lip",
        },
        {
            id: 26,
            q: "",
        },
        {
            id: 27,
            q: "",
        },
        {
            id: 28,
            q: "",
        },
        {
            id: 29,
            q: "",
        },
        {
            id: 30,
            q: "",
            calc: true,
            from: 26,
            group: "heart",
        },
        {
            id: 31,
            q: "",
        },
        {
            id: 32,
            q: "",
        },
        {
            id: 33,
            q: "",
        },
        {
            id: 34,
            q: "",
        },
        {
            id: 35,
            q: "",
            calc: true,
            from: 31,
            group: "ears",
        },
        {
            id: 36,
            q: "",
        },
        {
            id: 37,
            q: "",
        },
        {
            id: 38,
            q: "",
        },
        {
            id: 39,
            q: "",
        },
        {
            id: 40,
            q: "",
            calc: true,
            from: 36,
            group: "rightHand",
        },
        {
            id: 41,
            q: "",
        },
        {
            id: 42,
            q: "",
        },
        {
            id: 43,
            q: "",
        },
        {
            id: 44,
            q: "",
        },
        {
            id: 45,
            q: "",
            calc: true,
            from: 41,
            group: "leftHand",
        },
        {
            id: 46,
            q: "",
        },
        {
            id: 47,
            q: "",
        },
        {
            id: 48,
            q: "",
        },
        {
            id: 49,
            q: "",
        },
        {
            id: 50,
            q: "",
            calc: true,
            from: 46,
            group: "rightLeg",
        },
        {
            id: 51,
            q: "",
        },
        {
            id: 52,
            q: "",
        },
        {
            id: 53,
            q: "",
        },
        {
            id: 54,
            q: "",
        },
        {
            id: 55,
            q: "",
            calc: true,
            from: 51,
            group: "waist",
        },
        {
            id: 56,
            q: "",
            end: true,
        }
    ];

    const [loading, setLoading] = useState(true);
    const [yourTestFinished, setYourTestFinished] = useState(false);
    const [toast, setToast] = useState({show: false, message: null});
    const [requestId, setRequestId] = useState(null);
    const [customerId, setCustomerId] = useState(null);
    const [mobile, setMobile] = useState('');
    const [questions, updateQuestions] = useState([]);
    const [showResult, setShowResult] = useState(false);
    const [activeKey, setActiveKey] = useState(0);
    const [group, setGroup] = useState({
        brain: 0,
        eye: 0,
        hair: 0,
        nose: 0,
        lip: 0,
        heart: 0,
        ears: 0,
        rightHand: 0,
        leftHand: 0,
        rightLeg: 0,
        waist: 0,
    });
    const [groupSize, setGroupSize] = useState({
        hair: 1,
        brain: 1,
        eye: 1,
        ears: 1,
        nose: 1,
        lip: 1,
        waist: 1,
        rightHand: 1,
        leftHand: 1,
        rightLeg: 1,
        heart: 1,
    });

    useEffect(() => {
        if (questions.length === 0) {
            setLoading(true);
            service.getQuestions().then((response) => {
                if (response.status === 200) {
                    const data = response.data;

                    _question.forEach((question) => {
                        const findQuestionId = data.find(x => x.id === question.id);
                        if (findQuestionId) {
                            question.q = findQuestionId.content;
                        }
                    })

                    updateQuestions(_question);
                    setLoading(false);
                }
            })
        }

        const url = new URL(window.location.href);
        const questionId = url.searchParams.get('q');
        if (questionId) {

        }

    }, [_question, questions, window.location, loading])

    const select = (question, value) => {
        const clone = [...questions];
        const findQuestion = clone.find(x => x.id === question.id);
        if (findQuestion) {
            findQuestion.value = parseInt(value);
            if (findQuestion.calc) {
                let total = 0;
                const from = findQuestion.from - 1;
                const to = findQuestion.id + 1;

                questions.forEach((question) => {
                    if (question.id > from && question.id < to) {
                        total += question.value;
                    }
                })

                group[findQuestion.group] = total;

                setGroup(group);
            }

            setLoading(true);
            service.addCustomerQuestion({
                customer_id: customerId,
                question_id: question.id,
                response: value
            }).then((response) => {
                if (response.status === 200) {
                    window.history.pushState(null, "", `/?id=${customerId}&q=${question.id + 1}`);
                    setActiveKey(question.id + 1)
                    setLoading(false);
                }
            })

            const endQuestion = clone.find(x => x.id === question.id + 1);

            if (endQuestion) {
                if (endQuestion.end) {
                    for (const key in group) {
                        analyze(key, group[key]);
                    }
                }
            }
        }
    }

    const analyze = (key, value) => {
        if (value >= 5 && value <= 8) {
            //very small
            groupSize[key] = 1;
            setGroupSize(groupSize);
        } else if (value >= 9 && value <= 12) {
            //small
            groupSize[key] = 2;
            setGroupSize(groupSize);
        } else if (value >= 13 && value <= 16) {
            //normal
            groupSize[key] = 3;
            setGroupSize(groupSize);
        } else if (value >= 17 && value <= 21) {
            //big
            groupSize[key] = 4;
            setGroupSize(groupSize);
        } else if (value >= 22 && value <= 25) {
            //very big
            groupSize[key] = 5;
            setGroupSize(groupSize);
        }
    }

    const updateQuestionsMethod = (responses) => {
        const qs = [...questions];
        qs.forEach((question) => {
            const findQuestionId = responses.find(x => x.question_id === question.id);
            if (findQuestionId) {
                question.value = findQuestionId.response;

                if (question.calc) {
                    let total = 0;
                    const from = question.from - 1;
                    const to = question.id + 1;

                    questions.forEach((question) => {
                        if (question.id > from && question.id < to) {
                            total += question.value;
                        }
                    })

                    group[question.group] = total;
                    setGroup(group);
                }
            }
        })
        updateQuestions(qs);
    }

    const start = () => {
        service.addCustomer({mobile: mobile}).then((response) => {
            if (response.status === 200) {
                const data = response.data;
                setCustomerId(data.id);
                window.history.pushState(null, "", `/?id=${data.id}&q=1`);
                setActiveKey(1)
            }
        }, (e) => {
            const requestId = e.response.data['requestId'];
            const customerId = e.response.data['customerId'];
            setDialog(true);
            setCustomerId(customerId);
            setRequestId(requestId);
        })
    }

    const processCurrentTest = () => {
        service.hasBeenFinished(mobile).then((response) => {
            if (response.status === 200) {
                const data = response.data;
                if (data.finished) {
                    updateQuestionsMethod(data['responses'])
                    setYourTestFinished(true);
                } else {
                    updateQuestionsMethod(data['responses'])
                    window.history.pushState(null, "", `/?id=${customerId}&q=${data.last}`);
                    setActiveKey(data.last);
                    setDialog(false);
                }
            }
        })
    }

    const wantToShowTheResult = () => {
        setDialog(false);
        for (const key in group) {
            analyze(key, group[key]);
        }
        setShowResult(true)
    }

    const back = (question) => {
        window.history.pushState(null, "", `/?id=${customerId}&q=${question.id - 1}`);
        setActiveKey(question.id - 1);
    }

    const newRequest = () => {
        service.newTest({'customer_id': customerId, 'request_id': requestId}).then((response) => {
            if (response.status === 200) {
                window.history.pushState(null, "", `/?id=${customerId}&q=1`);
                setActiveKey(1);
                setDialog(false);
            }
        }, () => {
            setToast({message: "از تست قبلی باید 48 ساعت گذشته باشد", show: true})
            setDialog(false);
        })
    }

    return (
        <div className="container h-100 p-0">
            {
                showResult ? <>
                        <Human result={groupSize}/>
                    </> :
                    <>
                        <Carousel controls={false} interval={null} activeIndex={activeKey} className={'h-100'}
                                  indicators={false}>
                            {
                                questions.map((question) => {
                                    return <Carousel.Item
                                        className={`h-100 ${question.id !== 56 ? 'yasi' : ''}`}
                                        key={question.id}>
                                        {
                                            question.id === 0 ? <>
                                                <Carousel.Caption className={'p-0 position-absolute top-0 pt-3 z-1'}>
                                                    <img src={'logo-w.png'} alt={'bita'}/>
                                                    <h5 className={'mb-0 mt-3'}>
                                                        پرسشنامه ارزیابی
                                                    </h5>
                                                    <h1 className={'mb-5 text-warning fw-bolder'}>
                                                        نیمرخ پنهان
                                                    </h1>

                                                    <h6>
                                                        طراحی پرسشنامه
                                                    </h6>
                                                    <h2 className={'text-warning'}>
                                                        دکتر بیتا حسینی
                                                    </h2>

                                                    <div className={'row'}>
                                                        <div className={'col-12 col-lg-4 mx-auto'}>
                                                            <video
                                                                poster={'cover1.jpeg'}
                                                                className={'w-100 rounded-4 mt-3'}
                                                                controls>
                                                                <source src="intro.mp4" type="video/mp4"/>
                                                            </video>
                                                        </div>
                                                    </div>

                                                    <div className={'position-absolute bottom-0 w-100'}>
                                                        <div className={'row'}>
                                                            <div className={'col-12 col-lg-4 mx-auto'}>
                                                                <Button variant="link"
                                                                        className={'mb-3 w-100 text-light text-decoration-none'}
                                                                        onClick={handleShow}>
                                                                    پیش گفتار
                                                                </Button>

                                                                <div className={'mb-3'}>
                                                                    <input
                                                                        className={'form-control form-control-lg text-center'}
                                                                        type={'tel'}
                                                                        placeholder={'شماره همراه'}
                                                                        onChange={(e) => setMobile(e.target.value)}/>
                                                                </div>

                                                                <Button
                                                                    disabled={loading}
                                                                    variant={'warning'} size={'lg'} className={'w-100'}
                                                                    onClick={start}>
                                                                    {loading ? 'در حال بارگذاری' : 'شروع تست'}
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Carousel.Caption>
                                            </> : null
                                        }
                                        {
                                            question.id === 56 ? <>
                                                <Carousel.Caption className={'p-0 position-absolute top-0 pt-3'}>
                                                    <div className={'rounded-3 py-3 mb-3'}>
                                                        <img src={'logo.png'} alt={'bita'}/>
                                                    </div>
                                                    <h5 className={'mb-0 mt-3 text-dark'}>
                                                        پرسشنامه ارزیابی
                                                    </h5>
                                                    <h1 className={'mb-5 text-warning fw-bolder'}>
                                                        نیمرخ پنهان
                                                    </h1>

                                                    <div
                                                        className={'bg-black h-25 mt-5 overflow-hidden position-relative rounded w-100'}>
                                                        <video
                                                            className={'bg-video'} muted={true} loop={true}
                                                            autoPlay={true}>
                                                            <source src="intro1.mp4" type="video/mp4"/>
                                                        </video>
                                                    </div>

                                                    <div className={'position-absolute bottom-0 w-100'}>
                                                        <Button variant={'success'} size={'lg'} className={'w-100'}
                                                                onClick={() => setShowResult(true)}>مشاهده
                                                            نتیجه</Button>
                                                    </div>
                                                </Carousel.Caption>
                                            </> : null
                                        }
                                        {
                                            question.id > 0 && question.id < 56 ? <>
                                                <Carousel.Caption
                                                    className={'p-0 position-absolute start-0 w-100 px-3 top-0 pt-3'}>
                                                    <div
                                                        className={'position-absolute start-50 translate-middle-x w-50 bg-warning py-1 text-dark lh-sm rounded-pill'}>
                                                        پرسش <b>{question.id}</b> از <b>55</b>
                                                    </div>

                                                    <div className={'mt-5 pt-3'}>
                                                        <p className={'lh-base fs-5'}>{question.q}</p>
                                                    </div>

                                                    <fieldset disabled={loading}
                                                              className={'position-absolute bottom-0 w-100 start-0 mb-4 px-3'}>
                                                        <Button size={'sm'} variant={'light'}
                                                                className={'w-100 mb-2 rounded-pill'}
                                                                onClick={() => select(question, 1)}>
                                                            اصلاً این‌جوری نیست
                                                        </Button>
                                                        <Button size={'sm'} variant={'light'}
                                                                className={'w-100 mb-2 rounded-pill'}
                                                                onClick={() => select(question, 2)}>
                                                            گاهی این‌جوریه
                                                        </Button>
                                                        <Button size={'sm'} variant={'light'}
                                                                className={'w-100 mb-2 rounded-pill'}
                                                                onClick={() => select(question, 3)}>
                                                            معمولاً این‌جوریم
                                                        </Button>
                                                        <Button size={'sm'} variant={'light'}
                                                                className={'w-100 mb-2 rounded-pill'}
                                                                onClick={() => select(question, 4)}>
                                                            تقریباً همیشه این‌جوریم
                                                        </Button>
                                                        <Button size={'sm'} variant={'light'}
                                                                className={'w-100 mb-3 rounded-pill'}
                                                                onClick={() => select(question, 5)}>
                                                            دقیقاً این حرف درباره من صدق می‌کنه
                                                        </Button>
                                                        <Button variant={'outline-light'}
                                                                className={'w-100 rounded-pill'}
                                                                onClick={() => back(question)}>
                                                            بازگشت
                                                        </Button>
                                                    </fieldset>
                                                </Carousel.Caption>
                                            </> : null
                                        }
                                    </Carousel.Item>
                                })
                            }
                        </Carousel>
                    </>
            }

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>پیش گفتار</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        با یاد آگاهی کل و درود بر انرژی‌های روشن عالم هستی.
                    </p>
                    <p>
                        هم‌ریشه عزیز!
                    </p>
                    <p>
                        هم‌اکنون مشغول پاسخ دادن به پرسشنامهای برای کشف «خویشتنِ» خود هستید.
                    </p>
                    <p>
                        در این پرسشنامه، هیچ پاسخ درست یا غلطی وجود ندارد و در پایان نیز هیچ قضاوتی درباره شما نخواهد
                        شد.
                        این پرسشنامه، تنها برای آشنایی بیشتر شما با ضمیر ناخودآگاه‌تان طراحی شده است. پاسخ دقیق به آن
                        می‌تواند به شما کمک کند تا تصویر کامل‌تری از نیم‌رخ درونی خود به دست آورید.
                        لطفاً به نکات زیر توجه کنید:
                    </p>
                    <p>
                        هنگام پاسخ دادن به سوالات، به کلیت کسی که تاکنون بوده‌اید فکر کنید، نه فقط به یک سال گذشته یا
                        بحرانی
                        که اکنون در آن به سر میبرید.
                    </p>
                    <p>
                        در پایان هر سؤال، اعداد ۱، ۲، ۳، ۴ و ۵ وجود دارد. هر چقدر آن سؤال بیشتر در مورد شما صدق می‌کند،
                        عدد
                        بزرگ‌تر را انتخاب کنید. برای مثال، در سؤالی مانند «من آدم غمگین و مآیوسی هستم»، اگر معتقدید که
                        اصلاً
                        اینطور نیست، عدد ۱؛ اگر معتقدید گاهی اینطور است، عدد2؛ اگر معولاً‌اینطور است، عدد 3؛ اگر تقریباً
                        همیشه اینطور است، عدد ۴و اگر دقیقاً درباره شما صدق می‌کند، عدد ۵ را انتخاب کنید.
                        نیازی نیست وسواس به خرج دهید؛ فقط کافی است یک لحظه مکث کنید و با توجه به کلیت سؤال و اولین چیزی
                        که
                        به ذهنتان میرسد، یک عدد را انتخاب کنید.
                    </p>
                    <p>
                        اگر برخی سوالات چند بخش دارند و تنها بخشی از آن‌ها در مورد شما صدق می‌کند، بهتر است با توجه به
                        بخشی
                        که در مورد شما صادق است، از بین تا 5 یک گزینه را انتخاب کنید.
                        در پایان، از شما به خاطر شجاعت‌تان برای تماشای خویشتن درونی خود تشکر می‌کنم. بسیاری از انسان‌ها
                        هرگز
                        حاضر نیستند دست از قضاوت و محکوم کردن دیگران بردارند و خود واقعی‌شان را به چالش بکشند.
                        شکوفایی درونتان را از هم‌اکنون به شما تبریک می‌گویم.
                    </p>
                    <p>
                        با احترام،
                    </p>
                    <p>
                        دکتر بیتا حسینی
                    </p>
                </Modal.Body>
            </Modal>


            <Modal show={dialog} onHide={() => setDialog(false)} className={'align-content-end'}>
                <Modal.Header closeButton>
                    <Modal.Title>عملیات</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    {
                        yourTestFinished ? <>
                                <div className={'mb-3'}>
                                    <Button variant={'primary'} className={'w-100 rounded-pill px-3'}
                                            onClick={newRequest}>انجام تست
                                        جدید</Button>
                                </div>
                                <div>
                                    <Button variant={'outline-primary'} className={'w-100 rounded-pill px-3'}
                                            onClick={wantToShowTheResult}>
                                        مشاهده نتیجه
                                    </Button>
                                </div>
                            </> :
                            <>
                                <div>
                                    <Button variant={'outline-primary'} className={'w-100 rounded-pill px-3'}
                                            onClick={processCurrentTest}>
                                        بررسی تست فعلی
                                    </Button>
                                </div>
                            </>
                    }
                </Modal.Body>
            </Modal>

            <ToastContainer position={"bottom-end"} className={'start-50 translate-middle position-fixed mb-3 z-3'}
                            onClick={() => setToast({show: false, message: null})}>
                <Toast onClose={() => setToast({show: false, message: null})}
                       show={toast.show}
                       className={'position-relative toast-light'}
                       delay={8000}
                       autohide={true}
                       autoFocus={true}
                       animation={true}>
                    <Toast.Body>
                        <img src="logo.png" width={50} alt=""/>
                        <span className={'ms-3'}>{toast.message}</span>
                    </Toast.Body>
                </Toast>
            </ToastContainer>
        </div>
    );
}

export default App;
